import { StudentEngagementData, UpdateStudentEngagementData } from '../../engagement/models/engagement-student.model';
import { StudentScholarshipData, UpdateStudentScholarshipData } from '../../scholarship/models/student-scholarship-data.model';

export class StudentData {
  studentId: number;
  name: string;
  surname: string;
  lastname: string;
  courseId: number;
  classroom: string;
  nacionality: number;
  birthday: Date;
  genderId: number;
  transferPayment: boolean;
  cauCode: string;
  card: string;
  annotations: string;
  studentDiets: number[];
  currentEngagementFamilyStudents: StudentEngagementData[];
  historicEngagementFamilyStudents: StudentEngagementData[];
  currentScholarshipFamilyStudents: StudentScholarshipData[];
  historicScholarshipFamilyStudents: StudentScholarshipData[];
}

export class CreateStudentRequest {
  schoolId: number;
  surname: string;
  lastname: string;
  name: string;
  familyId: number;
  courseId: number;
  phone: number;
  classroom: string;
  cauCode: string;
  email: string;
  card: string;
  nacionality: number;
  birthday: Date;
  genderId: number;
  transferPayment: boolean;
  identification: string;
  guardianIdentification: string;
  exerciseId: number;
}

export class UpdateStudentData {
  studentId: number;
  name: string;
  surname: string;
  lastname: string;
  courseId: number;
  classroom: string;
  nacionality: number;
  birthday: Date;
  gender: number;
  transferPayment: boolean;
  cauCode: string;
  card: string;
  email: string;
  guardianIdentification: string;
  annotations: string;
  studentDiets: number[];
  studentEngagements: UpdateStudentEngagementData[];
  studentScholarships: UpdateStudentScholarshipData[];
}

export class DeleteStudentRequest {
  familyId: number;
  studentId: number;
}
